export default{
      // ABOUT SUPPLIER
  for: "FOR",
  with: "with",
  grow_business: "Grow Your Supply Business",
  supplier_desc:
    "MAHAL is a B2B marketplace built to help suppliers connect directly with restaurants, receive consistent orders, and scale their business with confidence.",
  supplier_text:
    "From local producers to large distributors, MAHAL empowers suppliers with access to verified restaurants, transparent pricing, and long-term business partnerships — all in one platform.",

  highlight1: "Direct Access to Restaurants",
  highlight2: "Bulk & Recurring Orders",
  highlight3: "Timely & Secure Payments",
  highlight4: "Business Growth Support",

  become_supplier: "Become a Supplier",
  talk_team: "Talk to Our Team",
};
